import type { FC } from 'react';

import { ChipSelect, type ChipOption } from '@/shared/ui';
import type { ClientFilterType } from '@/features/clients';
import { TEST_IDS } from '@/testIds';

interface FilterChipsProps {
  value: ClientFilterType;
  onChange: (value: ClientFilterType) => void;
}

const filterOptions: ChipOption<ClientFilterType>[] = [
  { label: 'All', value: 'all' },
  { label: 'Active', value: 'active' },
  { label: 'Ends soon', value: 'expiringSoon' },
  { label: 'Expired', value: 'expired' },
];

export const FilterChips: FC<FilterChipsProps> = ({ value, onChange }) => (
  <ChipSelect
    options={filterOptions}
    value={value}
    onChange={onChange}
    ariaLabel="Client filters"
    testId={TEST_IDS.filterChips}
    chipTestId={(filterValue) => `filter-chip-${filterValue}`}
  />
);
